import BasePage from '../../../../../components/table_page';
import Form from './form';
import ScanList from './form/scan_list.vue';
import { ProcessLog } from '../../../../../modules';

export default {
  name: 'banquet_submission',
  extends: BasePage,
  data() {
    return {
      params: {
        banquetSource: '1', // 宴席类型 1-普通宴席 2-团购宴席
      },
    };
  },
  components: {
    Form,
    ScanList,
    ProcessLog,
  },
  created() {
    this.getConfigList('main_list');
  },
  methods: {
    // 控制按钮显示
    clickVisible({ row, val: { code } }) {
      const { approveStatus, processCode } = row;
      if (code === 'process_log' && !processCode) {
        return false;
      }
      if (code === 'edit' && (approveStatus !== '0' && approveStatus !== '3')) {
        return false;
      }
      return true;
    },
    modalClick({ val, row }) {
      if (val.code === 'add' || val.code === 'edit' || val.code === 'view') {
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };
        this.modalConfig.title = val.name || '查看';
        this.openFull();
      }
      if (val.code === 'scan_code_record') {
        this.formName = 'ScanList';
        this.propsObjInData.row = { banquetCode: row.banquetCode };
        this.modalConfig.title = '扫码记录';
        this.openFull();
      }
      if (val.code === 'process_log') {
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row: { processNo: row.processCode },
        };
        this.modalConfig.title = '流程日志';
        this.formName = 'ProcessLog';
        this.openDrawer();
      }
    },
  },
};
